import { createSlice } from '@reduxjs/toolkit';
import { MANAGE_EXTERNALUSERS } from '../../actions/ManageExternalUsers/ManageExternalUsersActionType';

const initialState = {
  manageExternaluserCycle: {
    isLoading: false,

    manageEmployeeCycles: {},

    data: null,
    errors: '',
    message: ''
  }
};

export const manageExternalUserCyclesSlice = createSlice({
  name: MANAGE_EXTERNALUSERS,
  initialState,
  reducers: {
    getManageExternalUserAction: (state) => {
      state.manageExternaluserCycle.isLoading = true;
      state.manageExternaluserCycle.errors = '';
    },
    getManageExternalUserSuccessAction: (state, action) => {
      if (action.payload) {
        state.manageExternaluserCycle.manageEmployeeCycles = action.payload;
      }
      state.manageExternaluserCycle.isLoading = false;
    },
    getManageExternalUserFailureAction: (state, action) => {
      // state.user.isLoading = false;
      state.manageExternaluserCycle.isLoading = false;
      state.manageExternaluserCycle.errors = action.payload;
    },

    setUpdateStatusExternalAction: (state) => {
      state.manageExternaluserCycle.isLoading = true;
      state.manageExternaluserCycle.errors = '';
      state.manageExternaluserCycle.message = '';
    },

    setUpdateStatusExternalSuccessAction: (state, action) => {
      state.manageExternaluserCycle.isLoading = false;
      const updated =
        typeof action.payload === 'number' ? action.payload : action.payload?.data;
      if (updated >= 1) {
        state.manageExternaluserCycle.message = 'User(s) deactivated successfully.';
        state.manageExternaluserCycle.errors = '';
      } else {
        state.manageExternaluserCycle.errors = 'Could not deactivate the selected user(s).';
        state.manageExternaluserCycle.message = '';
      }
    },
    setUpdateStatusExternalFailureAction: (state, action) => {
      state.manageExternaluserCycle.isLoading = false;
      state.manageExternaluserCycle.errors = action.payload;
      state.manageExternaluserCycle.message = '';
    },
    clearDeactivateExternalFeedbackAction: (state) => {
      state.manageExternaluserCycle.errors = '';
      state.manageExternaluserCycle.message = '';
    }
  }
});

export const {
  getManageExternalUserAction,
  getManageExternalUserFailureAction,
  getManageExternalUserSuccessAction,
  setUpdateStatusExternalAction,
  setUpdateStatusExternalSuccessAction,
  setUpdateStatusExternalFailureAction,
  clearDeactivateExternalFeedbackAction
} = manageExternalUserCyclesSlice.actions;

export default manageExternalUserCyclesSlice.reducer;
